import FieldProto from "../../fields3/proto/field-proto";
import React from "react";
import ModalEditCustomField from "./edit-custom-field/modal-edit-custom-field";
import ModalCustomField from "./custom-field/modal";
import ApiCustomFields from "../../gd/api/custom-fields";
import {CustomFieldScope} from "../../gd/const/fields/custom-fields-v1-const";

// const debug = "FieldDropdown_PopoverMenuMoreModalsCustomField"
const debug = false

export default class ModalsCustomField {

    ///// NEW - FIELD3 NOT TASK / PROJECT

    // used when we need to create a new field but not classic custom field
    // used in CRM (at least)
    createNewField(arrayOfExistingFieldIds: ID[], callback: callback) {
        gd.modal.showV4({
            className: 'modal-add-custom-field',
            component: require('./add-field/modal-add-field'),
            params: {
                arrayOfExistingFieldIds,
                onSubmit: (field: FieldProto)=>{
                    callback(field);
                },
            }
        });
    }

    editField(field: FieldProto, callback: callback, options = {disableRequired:false}) {
        gd.modal.showV4({
            className: 'modal-add-custom-field',
            component: require('./edit-field/modal-edit-field.jsx'),
            params: {
                field,
                disableRequired : options.disableRequired,
                onSubmit        : callback,
            }
        });
    }

    ////// OLD CustomField - TASK / PROJECT

    editCustomFieldV2(customFieldId:ID, callback?:callback) {

        debug && console.log(debug, "editCustomFieldV2() id = ", customFieldId, "callback=", callback)

        gd.modal.showV4({
            className   : 'modal-add-custom-field',
            component   : ModalEditCustomField,
            params      : {
                customFieldId   : customFieldId,
                callback        : callback
            }
        })
    }

    // this is deprecated - use editCustomFieldV2
    editCustomField({ title, organizationId, customField, onSubmit, callback }: {
        title           : string,
        organizationId  : ID,
        customField     : any,
        onSubmit?       : func,
        callback        : callback
    }) {

        debug && console.log(debug, "editCustomField()")

        gd.modal.showV4({
            className   : 'modal-add-custom-field',
            component   : ModalCustomField,
            params      : {
                newOnly: true,  // why
                title,
                organizationId, // need remove
                customField,
                onSubmit,
                callback
            }
        })
    }


    createProjectCustomFieldOfType(options :any/*{ projectId, taskTypeId, organizationId, newOnly, title }*/, callback:callback) {

        debug && console.log(debug, "createProjectCustomFieldOfType()")

        const project = gd.session.projects.get(options.projectId);

        gd.modal.showV4({
            className   : 'modal-add-custom-field',
            component   : ModalCustomField,
            params      : {
                newOnly         : true,
                project         : project,
                organizationId  : gd.companyId,
                title           : 'New Custom Field',
                scope           : [CustomFieldScope.PROJECT],
                mandatoryScope  : [CustomFieldScope.PROJECT],
                customFieldType : options.customFiledType,

                onSubmit: async (values:any) => {
                    console.log("new field values = ", values)

                    let response

                    try {

                        if (values.version === 3) {
                            // Patch case when try adding CF >19 i.e. task CF but Field3
                            const customFieldV3 : FieldProto = values as unknown as FieldProto
                            response = await ApiCustomFields.createCompanyCustomField(customFieldV3.label, customFieldV3.typeInteger, customFieldV3.fieldAccess!, customFieldV3.fieldParams).promise()
                        } else {
                            response = await ApiCustomFields.createCompanyCustomField(values.name, values.type, values.access, values.params).promise()
                        }


                    } catch (error) {
                        // @ts-ignore
                        gd.apiError(error)
                        gd.modal.hide()
                    }


                    const newCustomField = response.session[0].data;
                    if (callback) callback(newCustomField.id);
                    gd.modal.hide();



                    // const createCustomFieldRequest = ApiCustomFields.createCompanyCustomField(values.name, values.type, values.access, values.params);
                    //
                    // createCustomFieldRequest.done((data:any)=> {
                    //     const newCustomField = data.session[0].data;
                    //     if (callback) callback(newCustomField.id);
                    //     gd.modal.hide();
                    // });
                    //
                    // createCustomFieldRequest.fail((error:any)=>{
                    //     gd.apiError(error);
                    //     gd.modal.hide();
                    // });
                },
            }
        });
    }


    addCustomField(options:any /*{ projectId, taskTypeId, organizationId, newOnly, title }*/, callback:callback) {

        debug && console.log(debug, "addCustomField() options=", options)

        const { projectId, taskTypeId, newOnly, title } = options;
        let notification, project, taskType;
        const modalTitle = title ? title : 'New Custom Field';

        if (projectId) {
            project = gd.session.projects.get(projectId);
            notification = <p>Adding custom field to a project enables this field for <b>all</b> tasks of <b>all</b> types within the selected project.</p>;
        } else if (taskTypeId) {
            taskType = gd.session.taskTypes.get(taskTypeId);
            notification = <p>Adding custom field to a task type enables this field for <b>all</b> tasks (of the type) within <b>all</b> projects of your organization.</p>;
        }

        //default scope should be selected depending on where we initiated its creation
        const scope = options.scope ? options.scope : [gd.const.customFields.scope.TASK];

        gd.modal.showV4({
            className   : 'modal-add-custom-field',
            component   : ModalCustomField,
            params: {
                newOnly: newOnly,
                taskType: taskType,
                project: project,
                notification: notification,
                // organizationId: gd.companyId,
                title: modalTitle,
                scope: scope,
                mandatoryScope: options.mandatoryScope,
                customFieldType: options.customFiledType,

                onSubmit: (values:any)=>{

                    const addCustomFieldToProjectTaskType = (customFieldId:ID)=>{
                        let res;
                        if (projectId)          res = gd.api.CustomFields.addCustomFieldToProject(projectId, customFieldId);
                        else if (taskTypeId)    res = gd.api.CustomFields.addCustomFieldToTaskType(gd.companyId, taskTypeId, customFieldId);

                        if (res) {
                            res.done((data:any)=>{
                                if (callback) callback(customFieldId);
                                gd.modal.hide();
                            });

                            res.fail((error:any)=>{
                                gd.apiError(error);
                                gd.modal.hide();
                            });
                        } else {
                            if (callback) callback(customFieldId);
                        }
                    };

                    const addNewCustomFieldToOrganization = (name:string, type:any, access:any, params:any)=>{

                        const res = ApiCustomFields.createCompanyCustomField(name, type, access, params);

                        res.done((data:any)=>{
                            const newCustomField = data.session[0].data;
                            if(newCustomField) addCustomFieldToProjectTaskType(newCustomField.id);
                            else console.error("addNewCustomField new field not found", name, type, access, data.session[0].data);
                            gd.modal.hide();
                        });

                        res.fail((error:any)=>{
                            gd.apiError(error);
                            gd.modal.hide();
                        });
                    };

                    if (values.customFieldId) {
                        // Existing Field
                        addCustomFieldToProjectTaskType(values.customFieldId);
                    } else {


                        if (values.version === 3) {
                            // Patch case when try adding CF >19 i.e. task CF but Field3
                            const customFieldV3 : FieldProto = values as unknown as FieldProto
                            addNewCustomFieldToOrganization(customFieldV3.label, customFieldV3.typeInteger, customFieldV3.fieldAccess, customFieldV3.fieldParams);
                        } else {
                            addNewCustomFieldToOrganization(values.name, values.type, values.access, values.params);
                        }

                    }
                },
            }
        });
    }


}
